import { ArrowDownWideNarrow } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const SortIcon = DeckardIconWrapper({ Icon: ArrowDownWideNarrow });
